import { createI18n } from 'vue-i18n';
import { languages } from './locales/index.js';

// Jazyk aplikace se bere z cookie app_locale (nastavuje ji přepínač jazyka v Blade části)
export function getLocaleFromCookie() {
    const matches = document.cookie.match(/(?:^|;\s*)app_locale=([^;]*)/)
    return matches ? matches[1] : 'en'
}

// Sdílená instance i18n – vlastní modul, aby ji mohly používat i moduly mimo Vue komponenty
// (např. http.js) bez cyklického importu přes app.js.
const i18n = createI18n({
    locale: getLocaleFromCookie(),
    fallbackLocale: 'en',
    messages: {
        cs: languages.cs,
        en: languages.en,
    }
})

export default i18n;
